import { createSelector } from 'reselect';
import get from 'lodash/get';

export const selectRootState = state => get(state, 'board');

export const selectRelationshipPriority = createSelector(
  selectRootState,
  state => get(state, 'relationshipPriority.list', []),
);



// WEBPACK FOOTER //
// ./src/redux/board/selectors/relationshipPriority.js